import type { Components, Theme } from "@mui/material/styles";

const solidColorMap = {
    gray: {
        backgroundColor: "var(--mui-palette-gray-800)",
        color: "var(--mui-palette-common-white)",
    },
    green: {
        backgroundColor: "var(--mui-palette-green-600)",
        color: "var(--mui-palette-common-white)",
    },
    blue: {
        backgroundColor: "var(--mui-palette-blue-600)",
        color: "var(--mui-palette-common-white)",
    },
    lilac: {
        backgroundColor: "var(--mui-palette-lilac-600)",
        color: "var(--mui-palette-common-white)",
    },
    orange: {
        backgroundColor: "var(--mui-palette-orange-600)",
        color: "var(--mui-palette-common-white)",
    },
    blackAlpha: {
        backgroundColor: "var(--mui-palette-blackAlpha-500)",
        color: "var(--mui-palette-common-white)",
    },
};

const outlineColorMap = {
    gray: {
        borderColor: "var(--mui-palette-gray-400)",
        color: "var(--mui-palette-gray-800)",
        backgroundColor: "transparent",
    },
    green: {
        borderColor: "var(--mui-palette-green-600)",
        color: "var(--mui-palette-green-600)",
        backgroundColor: "transparent",
    },
};

export const MuiChip: Components<Theme>["MuiChip"] = {
    defaultProps: {
        variant: "outlined",
        size: "medium",
        color: "gray",
    },
    styleOverrides: {
        root: {
            textTransform: "none",
            fontWeight: 600,
            lineHeight: 1.15,
            height: "auto",
            border: "none",

            "& .MuiChip-label": {
                padding: 0,
                lineHeight: "inherit",
                overflow: "visible",
            },

            variants: [
                // Solid variants
                ...Object.entries(solidColorMap).map(([color, styles]) => ({
                    props: { variant: "filled" as const, color: color as keyof typeof solidColorMap },
                    style: styles,
                })),

                // Outline variants
                ...Object.entries(outlineColorMap).map(([color, styles]) => ({
                    props: { variant: "outlined" as const, color: color as keyof typeof outlineColorMap },
                    style: {
                        backgroundColor: styles.backgroundColor,
                        color: styles.color,
                        boxShadow: `inset 0 0 0 1px ${styles.borderColor}`,
                    },
                })),

                // Size: xs
                {
                    props: { size: "small" },
                    style: {
                        fontSize: "10px",
                        padding: "1px 8px 0 8px",
                        borderRadius: "16px",
                        lineHeight: 1.5,
                        "& .MuiChip-label": {
                            fontSize: "10px",
                        },
                    },
                },

                // Size: sm
                {
                    props: { size: "medium" },
                    style: {
                        fontSize: "14px",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        "& .MuiChip-label": {
                            fontSize: "14px",
                        },
                    },
                },

                // Size: md
                {
                    props: { size: "large" },
                    style: {
                        fontSize: "14px",
                        padding: "8px 8px",
                        borderRadius: "16px",
                        "& .MuiChip-label": {
                            fontSize: "14px",
                        },
                    },
                },
            ],
        },
        label: {
            fontWeight: 600,
        },
    },
};
